export { default } from './SvgIcon';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/SvgIcon/index.js
// module id = 93
// module chunks = 0